
import {Component, Vue} from 'vue-property-decorator';
import {RouterNameEnum} from "@/router/router.types";
import PageTitle from "@/UI/components/common/PageTitle.vue";

import VisitDetailFormComponent from "@/UI/components/forms/visits/detail/VisitDetailFormComponent.vue";

import VisitGeneralForm from "@/form/visits/visitGeneral";
import VisitCreateForm from "@/form/visits/visitCreate";
import { VisitsStore } from "@/store/modules/Visits";

@Component({
  components: {PageTitle, VisitDetailFormComponent}
})
export default class VisitDetail extends Vue {
  form = new VisitGeneralForm();
  visitForm  = new VisitCreateForm();

    async create(): Promise<void> {
      if (await this.visitForm.submit(VisitsStore.create)) {
      }
    }
}
